// Grabber dimensions shared by the Dropdown's Tamagui `Sheet` and Modal's
// `TrueSheet` so both present an identical handle.
export const SHEET_GRABBER_WIDTH = 36;
export const SHEET_GRABBER_HEIGHT = 5;
